/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as ShareRouteImport } from './routes/share'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RefundsRouteImport } from './routes/refunds'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as NoticesRouteImport } from './routes/notices'
import { Route as LoginRouteImport } from './routes/login'
import { Route as BrandsRouteImport } from './routes/brands'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as StudioSetupRouteImport } from './routes/studio_.setup'
import { Route as StudioConsoleRouteImport } from './routes/studio_.console'
import { Route as SettingsWorkspacesRouteImport } from './routes/settings.workspaces'
import { Route as SettingsStudioRouteImport } from './routes/settings.studio'
import { Route as SettingsShopsRouteImport } from './routes/settings.shops'
import { Route as SettingsProfileRouteImport } from './routes/settings.profile'
import { Route as SettingsLanguageRouteImport } from './routes/settings.language'
import { Route as SettingsHelpRouteImport } from './routes/settings.help'
import { Route as SettingsDeleteRouteImport } from './routes/settings.delete'
import { Route as SettingsClientsRouteImport } from './routes/settings.clients'
import { Route as InviteInvitationIdRouteImport } from './routes/invite.$invitationId'
import { Route as HousesHouseIdRouteImport } from './routes/houses.$houseId'
import { Route as BoardsBoardIdRouteImport } from './routes/boards.$boardId'
import { Route as RoomsRoomIdWalkRouteImport } from './routes/rooms.$roomId.walk'
import { Route as BoardsBoardIdVisitRouteImport } from './routes/boards.$boardId_.visit'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioRoute = StudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareRoute = ShareRouteImport.update({
  id: '/share',
  path: '/share',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RefundsRoute = RefundsRouteImport.update({
  id: '/refunds',
  path: '/refunds',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PlansRoute = PlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const NoticesRoute = NoticesRouteImport.update({
  id: '/notices',
  path: '/notices',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsRoute = BrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const StudioSetupRoute = StudioSetupRouteImport.update({
  id: '/studio_/setup',
  path: '/studio/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioConsoleRoute = StudioConsoleRouteImport.update({
  id: '/studio_/console',
  path: '/studio/console',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsWorkspacesRoute = SettingsWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsStudioRoute = SettingsStudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsShopsRoute = SettingsShopsRouteImport.update({
  id: '/shops',
  path: '/shops',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsLanguageRoute = SettingsLanguageRouteImport.update({
  id: '/language',
  path: '/language',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsHelpRoute = SettingsHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDeleteRoute = SettingsDeleteRouteImport.update({
  id: '/delete',
  path: '/delete',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsClientsRoute = SettingsClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => SettingsRoute,
} as any)
const InviteInvitationIdRoute = InviteInvitationIdRouteImport.update({
  id: '/invite/$invitationId',
  path: '/invite/$invitationId',
  getParentRoute: () => rootRouteImport,
} as any)
const HousesHouseIdRoute = HousesHouseIdRouteImport.update({
  id: '/houses/$houseId',
  path: '/houses/$houseId',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardsBoardIdRoute = BoardsBoardIdRouteImport.update({
  id: '/boards/$boardId',
  path: '/boards/$boardId',
  getParentRoute: () => rootRouteImport,
} as any)
const RoomsRoomIdWalkRoute = RoomsRoomIdWalkRouteImport.update({
  id: '/rooms/$roomId/walk',
  path: '/rooms/$roomId/walk',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardsBoardIdVisitRoute = BoardsBoardIdVisitRouteImport.update({
  id: '/boards/$boardId_/visit',
  path: '/boards/$boardId/visit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/brands': typeof BrandsRoute
  '/login': typeof LoginRoute
  '/notices': typeof NoticesRoute
  '/onboarding': typeof OnboardingRoute
  '/plans': typeof PlansRoute
  '/privacy': typeof PrivacyRoute
  '/refunds': typeof RefundsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRouteWithChildren
  '/share': typeof ShareRoute
  '/studio': typeof StudioRoute
  '/terms': typeof TermsRoute
  '/boards/$boardId': typeof BoardsBoardIdRoute
  '/houses/$houseId': typeof HousesHouseIdRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/settings/clients': typeof SettingsClientsRoute
  '/settings/delete': typeof SettingsDeleteRoute
  '/settings/help': typeof SettingsHelpRoute
  '/settings/language': typeof SettingsLanguageRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/shops': typeof SettingsShopsRoute
  '/settings/studio': typeof SettingsStudioRoute
  '/settings/workspaces': typeof SettingsWorkspacesRoute
  '/studio/console': typeof StudioConsoleRoute
  '/studio/setup': typeof StudioSetupRoute
  '/settings/': typeof SettingsIndexRoute
  '/boards/$boardId/visit': typeof BoardsBoardIdVisitRoute
  '/rooms/$roomId/walk': typeof RoomsRoomIdWalkRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/brands': typeof BrandsRoute
  '/login': typeof LoginRoute
  '/notices': typeof NoticesRoute
  '/onboarding': typeof OnboardingRoute
  '/plans': typeof PlansRoute
  '/privacy': typeof PrivacyRoute
  '/refunds': typeof RefundsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/share': typeof ShareRoute
  '/studio': typeof StudioRoute
  '/terms': typeof TermsRoute
  '/boards/$boardId': typeof BoardsBoardIdRoute
  '/houses/$houseId': typeof HousesHouseIdRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/settings/clients': typeof SettingsClientsRoute
  '/settings/delete': typeof SettingsDeleteRoute
  '/settings/help': typeof SettingsHelpRoute
  '/settings/language': typeof SettingsLanguageRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/shops': typeof SettingsShopsRoute
  '/settings/studio': typeof SettingsStudioRoute
  '/settings/workspaces': typeof SettingsWorkspacesRoute
  '/studio/console': typeof StudioConsoleRoute
  '/studio/setup': typeof StudioSetupRoute
  '/settings': typeof SettingsIndexRoute
  '/boards/$boardId/visit': typeof BoardsBoardIdVisitRoute
  '/rooms/$roomId/walk': typeof RoomsRoomIdWalkRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/brands': typeof BrandsRoute
  '/login': typeof LoginRoute
  '/notices': typeof NoticesRoute
  '/onboarding': typeof OnboardingRoute
  '/plans': typeof PlansRoute
  '/privacy': typeof PrivacyRoute
  '/refunds': typeof RefundsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRouteWithChildren
  '/share': typeof ShareRoute
  '/studio': typeof StudioRoute
  '/terms': typeof TermsRoute
  '/boards/$boardId': typeof BoardsBoardIdRoute
  '/houses/$houseId': typeof HousesHouseIdRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/settings/clients': typeof SettingsClientsRoute
  '/settings/delete': typeof SettingsDeleteRoute
  '/settings/help': typeof SettingsHelpRoute
  '/settings/language': typeof SettingsLanguageRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/shops': typeof SettingsShopsRoute
  '/settings/studio': typeof SettingsStudioRoute
  '/settings/workspaces': typeof SettingsWorkspacesRoute
  '/studio_/console': typeof StudioConsoleRoute
  '/studio_/setup': typeof StudioSetupRoute
  '/settings/': typeof SettingsIndexRoute
  '/boards/$boardId_/visit': typeof BoardsBoardIdVisitRoute
  '/rooms/$roomId/walk': typeof RoomsRoomIdWalkRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/brands'
    | '/login'
    | '/notices'
    | '/onboarding'
    | '/plans'
    | '/privacy'
    | '/refunds'
    | '/reset-password'
    | '/settings'
    | '/share'
    | '/studio'
    | '/terms'
    | '/boards/$boardId'
    | '/houses/$houseId'
    | '/invite/$invitationId'
    | '/settings/clients'
    | '/settings/delete'
    | '/settings/help'
    | '/settings/language'
    | '/settings/profile'
    | '/settings/shops'
    | '/settings/studio'
    | '/settings/workspaces'
    | '/studio/console'
    | '/studio/setup'
    | '/settings/'
    | '/boards/$boardId/visit'
    | '/rooms/$roomId/walk'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/brands'
    | '/login'
    | '/notices'
    | '/onboarding'
    | '/plans'
    | '/privacy'
    | '/refunds'
    | '/reset-password'
    | '/share'
    | '/studio'
    | '/terms'
    | '/boards/$boardId'
    | '/houses/$houseId'
    | '/invite/$invitationId'
    | '/settings/clients'
    | '/settings/delete'
    | '/settings/help'
    | '/settings/language'
    | '/settings/profile'
    | '/settings/shops'
    | '/settings/studio'
    | '/settings/workspaces'
    | '/studio/console'
    | '/studio/setup'
    | '/settings'
    | '/boards/$boardId/visit'
    | '/rooms/$roomId/walk'
  id:
    | '__root__'
    | '/'
    | '/brands'
    | '/login'
    | '/notices'
    | '/onboarding'
    | '/plans'
    | '/privacy'
    | '/refunds'
    | '/reset-password'
    | '/settings'
    | '/share'
    | '/studio'
    | '/terms'
    | '/boards/$boardId'
    | '/houses/$houseId'
    | '/invite/$invitationId'
    | '/settings/clients'
    | '/settings/delete'
    | '/settings/help'
    | '/settings/language'
    | '/settings/profile'
    | '/settings/shops'
    | '/settings/studio'
    | '/settings/workspaces'
    | '/studio_/console'
    | '/studio_/setup'
    | '/settings/'
    | '/boards/$boardId_/visit'
    | '/rooms/$roomId/walk'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BrandsRoute: typeof BrandsRoute
  LoginRoute: typeof LoginRoute
  NoticesRoute: typeof NoticesRoute
  OnboardingRoute: typeof OnboardingRoute
  PlansRoute: typeof PlansRoute
  PrivacyRoute: typeof PrivacyRoute
  RefundsRoute: typeof RefundsRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  ShareRoute: typeof ShareRoute
  StudioRoute: typeof StudioRoute
  TermsRoute: typeof TermsRoute
  BoardsBoardIdRoute: typeof BoardsBoardIdRoute
  HousesHouseIdRoute: typeof HousesHouseIdRoute
  InviteInvitationIdRoute: typeof InviteInvitationIdRoute
  StudioConsoleRoute: typeof StudioConsoleRoute
  StudioSetupRoute: typeof StudioSetupRoute
  BoardsBoardIdVisitRoute: typeof BoardsBoardIdVisitRoute
  RoomsRoomIdWalkRoute: typeof RoomsRoomIdWalkRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio': {
      id: '/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof StudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share': {
      id: '/share'
      path: '/share'
      fullPath: '/share'
      preLoaderRoute: typeof ShareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refunds': {
      id: '/refunds'
      path: '/refunds'
      fullPath: '/refunds'
      preLoaderRoute: typeof RefundsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans': {
      id: '/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notices': {
      id: '/notices'
      path: '/notices'
      fullPath: '/notices'
      preLoaderRoute: typeof NoticesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands': {
      id: '/brands'
      path: '/brands'
      fullPath: '/brands'
      preLoaderRoute: typeof BrandsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/studio_/setup': {
      id: '/studio_/setup'
      path: '/studio/setup'
      fullPath: '/studio/setup'
      preLoaderRoute: typeof StudioSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio_/console': {
      id: '/studio_/console'
      path: '/studio/console'
      fullPath: '/studio/console'
      preLoaderRoute: typeof StudioConsoleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/workspaces': {
      id: '/settings/workspaces'
      path: '/workspaces'
      fullPath: '/settings/workspaces'
      preLoaderRoute: typeof SettingsWorkspacesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/studio': {
      id: '/settings/studio'
      path: '/studio'
      fullPath: '/settings/studio'
      preLoaderRoute: typeof SettingsStudioRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/shops': {
      id: '/settings/shops'
      path: '/shops'
      fullPath: '/settings/shops'
      preLoaderRoute: typeof SettingsShopsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/language': {
      id: '/settings/language'
      path: '/language'
      fullPath: '/settings/language'
      preLoaderRoute: typeof SettingsLanguageRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/help': {
      id: '/settings/help'
      path: '/help'
      fullPath: '/settings/help'
      preLoaderRoute: typeof SettingsHelpRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/delete': {
      id: '/settings/delete'
      path: '/delete'
      fullPath: '/settings/delete'
      preLoaderRoute: typeof SettingsDeleteRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/clients': {
      id: '/settings/clients'
      path: '/clients'
      fullPath: '/settings/clients'
      preLoaderRoute: typeof SettingsClientsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/invite/$invitationId': {
      id: '/invite/$invitationId'
      path: '/invite/$invitationId'
      fullPath: '/invite/$invitationId'
      preLoaderRoute: typeof InviteInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/houses/$houseId': {
      id: '/houses/$houseId'
      path: '/houses/$houseId'
      fullPath: '/houses/$houseId'
      preLoaderRoute: typeof HousesHouseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/boards/$boardId': {
      id: '/boards/$boardId'
      path: '/boards/$boardId'
      fullPath: '/boards/$boardId'
      preLoaderRoute: typeof BoardsBoardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rooms/$roomId/walk': {
      id: '/rooms/$roomId/walk'
      path: '/rooms/$roomId/walk'
      fullPath: '/rooms/$roomId/walk'
      preLoaderRoute: typeof RoomsRoomIdWalkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/boards/$boardId_/visit': {
      id: '/boards/$boardId_/visit'
      path: '/boards/$boardId/visit'
      fullPath: '/boards/$boardId/visit'
      preLoaderRoute: typeof BoardsBoardIdVisitRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SettingsRouteChildren {
  SettingsClientsRoute: typeof SettingsClientsRoute
  SettingsDeleteRoute: typeof SettingsDeleteRoute
  SettingsHelpRoute: typeof SettingsHelpRoute
  SettingsLanguageRoute: typeof SettingsLanguageRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsShopsRoute: typeof SettingsShopsRoute
  SettingsStudioRoute: typeof SettingsStudioRoute
  SettingsWorkspacesRoute: typeof SettingsWorkspacesRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsClientsRoute: SettingsClientsRoute,
  SettingsDeleteRoute: SettingsDeleteRoute,
  SettingsHelpRoute: SettingsHelpRoute,
  SettingsLanguageRoute: SettingsLanguageRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsShopsRoute: SettingsShopsRoute,
  SettingsStudioRoute: SettingsStudioRoute,
  SettingsWorkspacesRoute: SettingsWorkspacesRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BrandsRoute: BrandsRoute,
  LoginRoute: LoginRoute,
  NoticesRoute: NoticesRoute,
  OnboardingRoute: OnboardingRoute,
  PlansRoute: PlansRoute,
  PrivacyRoute: PrivacyRoute,
  RefundsRoute: RefundsRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SettingsRoute: SettingsRouteWithChildren,
  ShareRoute: ShareRoute,
  StudioRoute: StudioRoute,
  TermsRoute: TermsRoute,
  BoardsBoardIdRoute: BoardsBoardIdRoute,
  HousesHouseIdRoute: HousesHouseIdRoute,
  InviteInvitationIdRoute: InviteInvitationIdRoute,
  StudioConsoleRoute: StudioConsoleRoute,
  StudioSetupRoute: StudioSetupRoute,
  BoardsBoardIdVisitRoute: BoardsBoardIdVisitRoute,
  RoomsRoomIdWalkRoute: RoomsRoomIdWalkRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
